/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/185-clipboard': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M14.5 2H10a2 2 0 10-4 0H1.5a.5.5 0 00-.5.5v13a.5.5 0 00.5.5h13a.5.5 0 00.5-.5v-13a.5.5 0 00-.5-.5zM8 1a1 1 0 110 2 1 1 0 010-2zm6 14H2V3h2v1.5a.5.5 0 00.5.5h7a.5.5 0 00.5-.5V3h2v12z"/><path pid="1" d="M7 13.414L3.793 9.707l.914-.914L7 10.586l4.293-3.793.914.914z"/>'
  }
})
